import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

const initialState = {
	id: '',
	deleteList: [],
	checkedList: [],
	showdetails: false,
};

const InstructorSlice = createSlice({
	name: 'instructorDetail',
	initialState,
	reducers: {
		InstructorID: (state, action) => {
			state.id = action.payload;
			console.log('settrainingCenterID', state.id);
		},
		showInstructorDetails: (state, action) => {
			// console.log('Cake Action :', action);
			state.showdetails = action.payload;
		},
		setdeleteList: (state, action) => {
			state.deleteList = [...state.deleteList, action.payload];
		},
		setemptyDeleteList: (state) => {
			state.deleteList = [];
		},
		setfliterDeleteList: (state, action) => {
			state.deleteList = action.payload;
		},
		setcheckedList: (state, action) => {
			// console.log('reduxAction', action.payload);
			state.checkedList = [...state.checkedList, action.payload];
			// console.log('payloadSet', state.checkedList);
		},
		setemptycheckedList: (state, action) => {
			state.checkedList = [];
		},
		setflitercheckedList: (state, action) => {
			state.checkedList = action.payload;
		},
	},
});

export const {
	InstructorID,
	showInstructorDetails,
	setdeleteList,
	setcheckedList,
	setemptyDeleteList,
	setfliterDeleteList,
	setflitercheckedList,
	setemptycheckedList,
} = InstructorSlice.actions;

export const InstructorReducer = {
	// InstructorID: InstructorID.reducer,
	showInstructorDetails: InstructorSlice.reducer,
};
